/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useFormContext } from "react-hook-form";
import { RegisterOptions } from "react-hook-form/dist/types/validator";
import { Input, Description, Textarea } from "@nordcloud/gnui";
import {
  SidebarFormField,
  SidebarFormFieldProps,
} from "~/components/SidebarForm/SidebarFormField";

type Props = {
  name: string;
  placeholder?: string;
  registerOptions?: RegisterOptions;
  defaultValue?: string;
  inputType?: "text" | "number";
  textArea?: boolean;
} & SidebarFormFieldProps;

function SidebarTextField(props: Props) {
  const { register, errors } = useFormContext();

  React.useEffect(() => {
    register({ name: props.name });
  }, [props, register]);

  const inputId = props.inputId || `input-${props.name}`;
  const allRegisterOptions = {
    ...props.registerOptions,
    required: props.required || false,
  };

  const Component = props.textArea ? Textarea : Input;

  return (
    <SidebarFormField
      label={props.label}
      required={props.required}
      tooltip={props.tooltip}
      inputId={inputId}
    >
      <Component
        id={inputId}
        type={props.inputType || "text"}
        name={props.name}
        status={errors[props.name] && "danger"}
        placeholder={props.placeholder || props.label}
        defaultValue={props.defaultValue}
        ref={register(allRegisterOptions)}
      />

      {errors[props.name] && (
        <Description>
          {errors[props.name].message || "Please provide correct value"}
        </Description>
      )}
    </SidebarFormField>
  );
}

export { SidebarTextField };
